import { render } from "./HistoryRow.vue?vue&type=template&id=0ff3f724&scoped=true"
import script from "./HistoryRow.vue?vue&type=script&lang=js"
export * from "./HistoryRow.vue?vue&type=script&lang=js"

import "./HistoryRow.vue?vue&type=style&index=0&id=0ff3f724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff3f724"]])

export default __exports__